export default function Report(props) {
    const name = props.name
    const path = props.path
    return(
        <tr>
            <td className='ps-4 text-start' onClick={() => window.open(path,'_blank')}>{name}</td>
        </tr>
    )
}